import React, { FC, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import { LangValue } from '../../../../states/types/common'
import { setPath, setUrlParam } from '../../../../utils/url'
import ReportCardList from '../../../components/analyze/ReportCardList'
import ANALYZE_REPORT from '../../../constants/analyzeReport'
import { URL } from '../../../constants/url'

const Index: FC = () => {
  const { language } = useParams<{ language: LangValue }>()
  const history = useHistory()
  const location = useLocation()

  const clickReport = (type: string) => {
    history.push(`${setPath(setUrlParam(
      URL.ANALYZE_REPORT_DETAIL.path,
      [
        { key: 'type', value: type },
      ],
    ), language)}`)
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return (
    <section className="analyze_page">
      <Helmet>
        <title>Qasee - 組織分析 - 分析レポート</title>
      </Helmet>
      <section className="breadcrumb">
        <Link
          to={setPath(URL.ANALYZE.path, language)}
        >
          組織分析
        </Link>
        &nbsp;&gt;&nbsp;
        分析レポート
        &nbsp;
      </section>
      <section className="page_header">
        <h1>
          分析レポート
        </h1>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-header">
            <div className="title">
              分析レポート一覧
            </div>
          </div>
          <div className="block-detail">
            <ReportCardList
              clickReportCallback={clickReport}
              list={ANALYZE_REPORT}
            />
          </div>
        </div>
      </section>
    </section>
  )
}

export default Index
